import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { lazy, Suspense } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { useRecordContext } from "react-admin";
import { useTranslation } from "react-i18next";
import { ReadinessCheckButton } from "@/components/election-event/ReadinessCheckButton";
import { EEventDataMode, useElectionEventDataMode } from "./useElectionEventDataMode";
var EditElectionEventData = lazy(function () {
    return import("./EditElectionEventData").then(function (module) { return ({ default: module.EditElectionEventData }); });
});
/** No editor, form, save handler or configuration actions are mounted here. */
export var LockedDownDataTab = function () {
    var event = useRecordContext();
    var mode = useElectionEventDataMode(event);
    var t = useTranslation().t;
    if (mode === EEventDataMode.LOADING)
        return _jsx(CircularProgress, { "aria-label": t("loading") });
    if (!event || mode !== EEventDataMode.LOCKED_DOWN) {
        return _jsx(Alert, { severity: "info", children: t("electionEventScreen.dataUnavailable") });
    }
    return (_jsx(Box, { sx: { display: "flex", justifyContent: "flex-end", flexWrap: "wrap" }, children: _jsx(ReadinessCheckButton, { event: event }, event.id) }));
};
export var ElectionEventDataTab = function () {
    var event = useRecordContext();
    var mode = useElectionEventDataMode(event);
    var t = useTranslation().t;
    if (mode === EEventDataMode.LOADING)
        return _jsx(CircularProgress, { "aria-label": t("loading") });
    if (mode === EEventDataMode.UNAVAILABLE) {
        return _jsx(Alert, { severity: "info", children: t("electionEventScreen.dataUnavailable") });
    }
    if (mode === EEventDataMode.LOCKED_DOWN)
        return _jsx(LockedDownDataTab, {});
    return (_jsx(Suspense, { fallback: _jsx(CircularProgress, { "aria-label": t("loading") }), children: _jsx(EditElectionEventData, {}, event === null || event === void 0 ? void 0 : event.id) }));
};
